<script lang="ts">
export interface ProseOlProps {
  class?: any
}

export interface ProseOlSlots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseOlProps>()
defineSlots<ProseOlSlots>()
</script>

<template>
  <ol
    class="my-1.5 list-decimal ps-6"
    :class="props.class"
  >
    <slot />
  </ol>
</template>
